import React from 'react';
import Container from '@components/ui/container';
import { homeSixHeroBanner as heroBanner } from '@framework/static/banner';
import { useRouteLang } from 'src/hooks/use-route-lang';
import { useFetchFeaturedManufacturers } from '@framework/filters/get-featured-manufacturers-filter';

const HeroBannerCard = React.lazy(
  () => import('@components/hero/hero-banner-card'),
);
const CategoryGridBlock = React.lazy(
  () => import('@components/common/category-grid-block'),
);
const NewArrivalsProductFeed = React.lazy(
  () => import('@components/product/feeds/new-arrivals-product-feed'),
);
const OneSaleProductFeed = React.lazy(
  () => import('@components/product/feeds/on-sale-product-feed'),
);
const ManufacturerProductFeed = React.lazy(
  () => import('@components/product/feeds/manufacturer-product-feed'),
);

export default function HomePage() {
  const lang = useRouteLang();
  const {
    data: featuredManufacturers,
    isLoading,
    error,
  } = useFetchFeaturedManufacturers();

  return (
    <>
      <Container>
        <CategoryGridBlock lang={lang} />
      </Container>
      <HeroBannerCard
        lang={lang}
        banner={heroBanner}
        className="hero-banner-six py-20 py:pt-24 mb-5 2xl:bg-center"
      />
      <Container>
        <OneSaleProductFeed variant="alpine" lang={lang} />
        <NewArrivalsProductFeed variant="alpine" lang={lang} />
        {featuredManufacturers?.map((manufacturer) => (
          <ManufacturerProductFeed
            key={manufacturer.id}
            lang={lang}
            manufacturer={manufacturer}
          />
        ))}
      </Container>
    </>
  );
}
